import script from "./BoardWrite.vue?vue&type=script&lang=ts&setup=true"
export * from "./BoardWrite.vue?vue&type=script&lang=ts&setup=true"

import "./BoardWrite.vue?vue&type=style&index=0&id=c483a82c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c483a82c"]])

export default __exports__